export default function InformativaAppaltatore() {
  return (
    <div>
      <h1>Informativa sul trattamento dei dati personali</h1>
      <p>
        La presente informativa sul trattamento dei dati personali è resa, ai
        sensi dell’art. 13 del Regolamento (UE) 2016/679 (di seguito
        “Regolamento”), da Servizi & Gestioni Italia S.r.l., con sede legale in
        Via dell’Oceano Indiano 13, Roma (di seguito “Segit”), in qualità di
        Titolare del trattamento.
      </p>
      <p>
        In questa informativa le illustreremo le finalità e le modalità con cui
        Segit tratta i suoi dati personali nell’ambito dell’utilizzo
        dell’applicazione (di seguito “App Formazione”). La presente informativa
        integra l’informativa sul trattamento dei dati fornita in occasione
        della stipula del contratto di appalto.
      </p>

      <h2>1. Categorie di dati personali</h2>
      <p>
        Per consentirle l’utilizzo della App Formazione, Segit tratterà alcuni
        suoi dati personali. In particolare, Segit tratterà i dati
        identificativi dell’account (nome, cognome, e-mail, partita iva) e dati
        relativi all’identificazione del punto vendita (codice del punto
        vendita, indirizzo). Inoltre, Segit potrà trattare dati relativi
        all’utilizzo, da parte sua, delle funzionalità della App Formazione.
      </p>
      <p>
        Il conferimento dei dati personali indicati è necessario per consentirle
        l’utilizzo della App Formazione e la partecipazione alle iniziative di
        formazione svolte da Segit; in difetto, non sarà possibile consentirle
        l’accesso alla App Formazione e ai contenuti disponibili.
      </p>

      <h2>2. Finalità e base giuridica del trattamento</h2>
      <p>
        Segit tratterà i dati personali sopra indicati esclusivamente per
        consentirle di fruire delle funzionalità della App Formazione, ai sensi
        dell’art. 6, lett. b) del Regolamento. A titolo esemplificativo, i suoi
        dati personali saranno trattati per fornirle contenuti di carattere
        formativo in modalità e-learning resi disponibili tramite l’App
        Formazione.
      </p>
      <p>
        Per detta finalità, Segit tratterà tutti i dati personali indicati al
        punto 1.
      </p>

      <h2>
        3. Categorie di soggetti ai quali i dati personali possono essere
        comunicati e finalità della comunicazione
      </h2>
      <p>
        Segit la informa che soggetti terzi dei quali si avvale per lo
        svolgimento di attività connesse all’elaborazione e manutenzione della
        App Formazione, nonché all’erogazione del contenuto di formazione,
        potranno trattare alcuni dei suoi dati personali. In particolare, i suoi
        dati saranno trattati da Kuwait Petroleum Italia S.p.A. nonché da
        ulteriori società esterne che offrono a Segit servizi amministrativi, di
        manutenzione e di hosting. Tali società tratteranno i suoi dati
        personali in qualità di Responsabili del trattamento.
      </p>

      <p>
        L’elenco dei Responsabili del trattamento può essere richiesto scrivendo
        a <a href="mailto:segit_privacy@q8.it">segit_privacy@q8.it</a>
      </p>
      <p>
        Non è prevista alcuna forma di diffusione dei suoi dati a soggetti
        indeterminati.
      </p>

      <h2>4. Periodo di conservazione</h2>
      <p>
        I dati personali indicati al paragrafo 1 saranno trattati da Segit per
        tutto il tempo necessario a consentirle di fruire delle funzionalità
        della App Formazionee fino alla disattivazione dell’account.
      </p>

      <h2>5. Trasferimento dei dati fuori dall’Unione europea</h2>
      <p>
        I suoi dati potranno essere trasferiti fuori dall’Unione europea da
        parte di fornitori di servizi di cui Segit si avvale per attività
        connesse all’erogazione dei servizi tramite l’App Formazione. Tale
        trasferimento, ove ricorra il caso, verrà disciplinato con i fornitori
        di servizi mediante il ricorso a clausole contrattuali standard adottate
        dalla Commissione europea con la decisione 2021/914/EU ed eventuali
        successive modifiche o, in alternativa, sulla base di una decisione di
        adeguatezza della Commissione, sulla base di norme vincolanti di impresa
        e/o di ogni altro strumento consentito dalla normativa di riferimento.
        Potrà ottenere informazioni sul luogo in cui i suoi dati sono stati
        trasferiti e copia di tali dati, scrivendo a{" "}
        <a href="mailto:segit_privacy@q8.it">segit_privacy@q8.it</a>
      </p>

      <h2>6. Diritti degli interessati</h2>

      <p>
        La informiamo che, in conformità alla vigente disciplina, ha i seguenti
        diritti:
      </p>
      <ul>
        <li>
          chiedere e ottenere informazioni in merito all’esistenza di suoi dati
          personali presso la Società e in merito ai trattamenti di dati posti
          in essere dalla società nonché ottenere l’accesso a tali dati;
        </li>
        <li>
          chiedere ed ottenere la ricezione in un formato strutturato, di uso
          comune e leggibile da dispositivo automatico dei dati personali da lei
          forniti alla società, che siano trattati con mezzi automatizzati;
          potrà richiedere inoltre il trasferimento di tali dati ad altro
          titolare del trattamento;
        </li>
        <li>
          chiedere e ottenere la modifica e/o correzione dei suoi dati
          personali;
        </li>
        <li>
          chiedere e ottenere la cancellazione – e/o la limitazione del
          trattamento - dei suoi dati personali qualora si tratti di dati o
          informazioni non necessari – o non più necessari – per le finalità che
          precedono, quindi decorso il periodo di conservazione indicato al
          paragrafo che precede.
        </li>
      </ul>

      <p>
        Tali richieste potranno essere indirizzate a Segit attraverso il sito{" "}
        <a href="http://www.q8.it/">www.q8.it</a>, accedendo alla sezione
        “Policy Privacy”.
      </p>
      <p>
        La informiamo infine che ai sensi della disciplina vigente può proporre
        eventuali reclami riguardanti i trattamenti di suoi dati personali al
        Garante per la protezione dei dati personali.
      </p>
    </div>
  );
}
